const actions = {
  GET_DATA_BEGIN: 'WARRANTIES_GET_DATA_BEGIN',
  GET_DATA_SUCCESS: 'WARRANTIES_GET_DATA_SUCCESS',
  GET_DATA_ERR: 'WARRANTIES_GET_DATA_ERR',
  SET_NEW_WARRANTY: 'WARRANTIES_SET_NEW_WARRANTY',
  SET_EDIT_WARRANTY: 'WARRANTIES_SET_EDIT_WARRANTY',

  getDataBegin: () => {
    return {
      type: actions.GET_DATA_BEGIN,
    };
  },

  getDataSuccess: (data: any) => {
    return {
      type: actions.GET_DATA_SUCCESS,
      data,
    };
  },

  getDataErr: (err: any) => {
    return {
      type: actions.GET_DATA_ERR,
      err,
    };
  },

  setNewWarranty: (data: any) => {
    return {
      type: actions.SET_NEW_WARRANTY,
      data,
    };
  },

  setEditWarranty: (data: any) => {
    return {
      type: actions.SET_EDIT_WARRANTY,
      data,
    };
  },
};

export default actions;
